import { color } from '@/theme/tokens';

interface BrandMarkProps {
  /** Only the coral square (collapsed sidebar) */
  compact?: boolean;
  /** Light text for dark backgrounds */
  inverse?: boolean;
  size?: number;
  showCompany?: boolean;
}

/** Coral square (the block from the Quire Systems logo) + the Tempo wordmark. */
const BrandMark = ({ compact = false, inverse = true, size = 28, showCompany = true }: BrandMarkProps) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 11, minWidth: 0 }}>
    <span
      aria-hidden="true"
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.18), background: color.coral, flex: 'none' }}
    />
    {!compact && (
      <span style={{ display: 'grid', lineHeight: 1.15, minWidth: 0 }}>
        <span
          style={{
            fontSize: 19,
            fontWeight: 700,
            fontStretch: '112%',
            letterSpacing: '-0.01em',
            color: inverse ? color.white : color.text,
          }}
        >
          Tempo
        </span>
        {showCompany && (
          <span style={{ fontSize: 11, fontWeight: 500, color: inverse ? color.sidebarMuted : color.textMuted }}>
            by Quire Systems
          </span>
        )}
      </span>
    )}
  </span>
);

export default BrandMark;
